// @flow

import React from "react";

import { Close as StyledClose, HeaderInfo } from "./styles";
import Privacy from "src/components/chatroom/Privacy";
import {
  Header as StyledHeader,
  TitleRow,
} from "src/components/chatroom/Header/styles";
import Favourite from "src/components/chatroom/Header/Favourite";
import Launch from "src/containers/chatroom/Dialog/Launch";
import Related from "src/containers/chatroom/Related";
import Title from "src/containers/chatroom/Title/Edit";
import BreadCrumbs from "src/containers/BreadCrumbs";
import Owner from "src/containers/chatroom/Owner";
import Status from "src/components/Unifize/Status";
import Files from "src/containers/chatroom/Files";
import DueDate from "src/components/chatroom/DueDate";
import Priority from "src/components/chatroom/Priority";
import Icon from "src/icons";
import Members from "src/components/chatroom/Members";
import * as colors from "src/styles/constants/colors";
import appLocation from "src/constants/location";
import type { UnifizeChatRoom } from "src/types";

type Props = {
  room: UnifizeChatRoom,
  closeConversationModal: Function,
};

const Header = ({ room, closeConversationModal }: Props) => (
  <>
    {room ? (
      <StyledHeader>
        <BreadCrumbs roomId={room.id} />
        <TitleRow>
          <div>
            <Title roomId={room.id} location={appLocation.conversationDialog} />
            <Privacy roomId={room.id} />
            <Favourite roomId={room.id} />
          </div>
        </TitleRow>
        <HeaderInfo>
          <Status roomId={room.id} location={appLocation.conversationDialog} />
          <Owner roomId={room.id} location={appLocation.conversationDialog} />
          <Members
            roomId={room.id}
            location={appLocation.conversationDialog}
            address={room.address}
          />

          {room.type !== "direct" && room.type !== "group" ? (
            <DueDate
              roomId={room.id}
              location={appLocation.conversationDialog}
            />
          ) : null}
          {room.type === "workflow" ? (
            <Priority
              roomId={room.id}
              location={appLocation.conversationDialog}
            />
          ) : null}
          <Related roomId={room.id} />

          <Files roomId={room.id} />
        </HeaderInfo>
        <Launch roomId={room.id} />
        <StyledClose onClick={closeConversationModal}>
          <Icon
            type="close"
            color={colors.grey36}
            cursor="pointer"
            size="1.25em"
          />
        </StyledClose>
      </StyledHeader>
    ) : null}
  </>
);

export default Header;
